import { heroWithOnboardingFlowConfig } from '@tmh-website/components/blocks/HeroWithOnboardingFlow/HeroWithOnboardingFlow.config';
import { BlockConfigExport, ContentBlockId } from './blocks.types';

import { allBlocksConfig } from './lib/blocks/AllBlocks/AllBlocks.config';
import { articleCTACardBlockConfig } from './lib/blocks/ArticleCTACardBlock/ArticleCTACardBlock.config';
import { articleDownloadConfig } from './lib/blocks/ArticleDownload/ArticleDownload.config';
import { articleEmbeddedVideoConfig } from './lib/blocks/ArticleEmbeddedVideo/ArticleEmbeddedVideo.config';
import { articleEnumerationConfig } from './lib/blocks/ArticleEnumeration/ArticleEnumeration.config';
import { articleFAQConfig } from './lib/blocks/ArticleFAQ/ArticleFAQ.config';
import { articleHeadlineConfig } from './lib/blocks/ArticleHeadline/ArticleHeadline.config';
import { articleImageConfig } from './lib/blocks/ImageBlock/ArticleImage.config';
import { articleImageTextSliderConfig } from './lib/blocks/ArticleImageTextSlider/ArticleImageTextSlider.config';
import { articleLinkBlockConfig } from './lib/blocks/ArticleLinkBlock/ArticleLinkBlock.config';
import { articlePageNavigationAnchorConfig } from './lib/blocks/ArticlePageNavigationAnchor/ArticlePageNavigationAnchor.config';
import { articleQuoteConfig } from './lib/blocks/ArticleQuote/ArticleQuote.config';
import { articlesConfig } from './lib/blocks/Articles/Articles.config';
import { articlesMixConfig } from './lib/blocks/ArticlesMix/ArticlesMix.config';
import { articleTextConfig } from './lib/blocks/ArticleText/ArticleText.config';
import { authorSpotlightConfig } from './lib/blocks/AuthorSpotlight/AuthorSpotlight.config';
import { calculatorChargingCostConfig } from './lib/blocks/CalculatorChargingCost/CalculatorChargingCost.config';
import { calculatorChargingDurationConfig } from './lib/blocks/CalculatorChargingDuration/CalculatorChargingDuration.config';
import { calculatorSavingsConfig } from './lib/blocks/CalculatorSavings/CalculatorSavings.config';
import { cards360SliderConfig } from './lib/blocks/Cards360Slider/Cards360Slider.config';
import { cardsConfig } from './lib/blocks/Cards/Cards.config';
import { carModelSelectionAndSavingsConfig } from './lib/blocks/CarModelSelectionAndSavings/CarModelSelectionAndSavings.config';
import { carModelSelectionConfig } from './lib/blocks/CarModelSelection/CarModelSelection.config';
import { carsConfig } from './lib/blocks/Cars/Cars.config';
import { checkmarksConfig } from './lib/blocks/Checkmarks/Checkmarks.config';
import { codeSnippetConfig } from './lib/blocks/CodeSnippet/CodeSnippet.config';
import { compareConfig } from './lib/blocks/Compare/Compare.config';
import { contactConfig } from './lib/blocks/Contact/Contact.config';
import { contactHelpConfig } from './lib/blocks/ContactHelp/ContactHelp.config';
import { contactOptionsConfig } from './lib/blocks/ContactOptions/ContactOptions.config';
import { contactSupportConfig } from './lib/blocks/ContactSupport/ContactSupport.config';
import { ctaBannerConfig } from './lib/blocks/CTABanner/CTABanner.config';
import { ctaCardBlockConfig } from './lib/blocks/CTACardBlock/CTACardBlock.config';
import { ctaConfig } from './lib/blocks/CTA/CTA.config';
import { delayedPopupConfig } from './lib/blocks/DelayedPopup/DelayedPopup.config';
import { downloadsAndAssetsConfig } from './lib/blocks/DownloadsAndAssets/DownloadsAndAssets.config';
import { enumerationListConfig } from './lib/blocks/EnumerationList/EnumerationList.config';
import { eTCancellationFormConfig } from './lib/blocks/ETCancellationForm/ETCancellationForm.config';
import { faqConfig } from './lib/blocks/FAQ/FAQ.config';
import { faqWithTabsConfig } from './lib/blocks/FAQWithTabs/FAQWithTabs.config';
import { flippingLogosWithButtonsConfig } from './lib/blocks/FlippingLogosWithButtons/FlippingLogosWithButtons.config';
import { footnoteConfig } from './lib/blocks/Footnote/Footnote.config';
import { formConfig } from './lib/blocks/Form/Form.config';
import { galleryConfig } from './lib/blocks/Gallery/Gallery.config';
import { getInTouchConfig } from './lib/blocks/GetInTouch/GetInTouch.config';
import { growingArrowConfig } from './lib/blocks/GrowingArrow/GrowingArrow.config';
import { growingGraphConfig } from './lib/blocks/GrowingGraph/GrowingGraph.config';
import { headlineBlockConfig } from './lib/blocks/HeadlineBlock/HeadlineBlock.config';
import { headlineTextSideBySideConfig } from './lib/blocks/HeadlineTextSideBySide/HeadlineTextSideBySide.config';
import { headlineWithCTABlockConfig } from './lib/blocks/HeadlineWithCTABlock/HeadlineWithCTABlock.config';
import { heroConfig } from './lib/blocks/Hero/Hero.config';
import { heroFullScreenImageConfig } from './lib/blocks/HeroFullScreenImage/HeroFullScreenImage.config';
import { heroSliderConfig } from './lib/blocks/HeroSlider/HeroSlider.config';
import { heroTextConfig } from './lib/blocks/HeroText/HeroText.config';
import { heroVideoConfig } from './lib/blocks/HeroVideo/HeroVideo.config';
import { heroWithBreakingArrowMaskConfig } from './lib/blocks/HeroWithBreakingArrowMask/HeroWithBreakingArrowMask.config';
import { heroWithSmallImageAndArrowConfig } from './lib/blocks/HeroWithSmallImageAndArrow/HeroWithSmallImageAndArrow.config';
import { heroWithStaticArrowMaskConfig } from './lib/blocks/HeroWithStaticArrowMask/HeroWithStaticArrowMask.config';
import { highlightedProductSliderConfig } from './lib/blocks/HighlightedProductSlider/HighlightedProductSlider.config';
import { imageBlockConfig } from './lib/blocks/ImageBlock/ImageBlock.config';
import { imageTextboxSliderConfig } from './lib/blocks/ImageTextboxSlider/ImageTextboxSlider.config';
import { imageTextConfig } from './lib/blocks/ImageText/ImageText.config';
import { imageTextSliderConfig } from './lib/blocks/ImageTextSlider/ImageTextSlider.config';
import { imageTextTilesConfig } from './lib/blocks/ImageTextTiles/ImageTextTiles.config';
import { interactiveCardsConfig } from './lib/blocks/InteractiveCards/InteractiveCards.config';
import { interactiveGraphicConfig } from './lib/blocks/InteractiveGraphic/InteractiveGraphic.config';
import { interactiveGridCardsConfig } from './lib/blocks/InteractiveGridCards/InteractiveGridCards.config';
import { jobOpeningsConfig } from './lib/blocks/JobOpenings/JobOpenings.config';
import { linkButtonsConfig } from './lib/blocks/LinkButtons/LinkButtons.config';
import { linkCardsListConfig } from './lib/blocks/LinkCardsList/LinkCardsList.config';
import { milestonesSliderConfig } from './lib/blocks/MilestonesSlider/MilestonesSlider.config';
import { offerSimulatorConfig } from './lib/blocks/OfferSimulator/OfferSimulator.config';
import { onboardingFlowEyondConfig } from './lib/blocks/OnboardingFlowEyond/OnboardingFlowEyond.config';
import { onboardingFlowEyondNewTariffConfig } from './lib/blocks/OnboardingFlowEyondNewTariff/OnboardingFlowEyondNewTariff.config';
import { onboardingFlowMercedesConfig } from './lib/blocks/OnboardingFlowMercedes/OnboardingFlowMercedes.config';
import { onboardingFlowMobilizeDEConfig } from './lib/blocks/OnboardingFlowMobilizeDE/OnboardingFlowMobilizeDE.config';
import { onboardingFlowMobilizeFRConfig } from '@tmh-website/components/blocks/OnboardingFlowMobilizeFR/OnboardingFlowMobilizeFR.config';
import { pageNavigationConfig } from './lib/blocks/PageNavigation/PageNavigation.config';
import { partnersConfig } from './lib/blocks/Partners/Partners.config';
import { peopleSliderConfig } from './lib/blocks/PeopleSlider/PeopleSlider.config';
import { pressMailingListConfig } from './lib/blocks/PressMailingList/PressMailingList.config';
import { productsConfig } from './lib/blocks/Products/Products.config';
import { recommendedProductsSliderConfig } from './lib/blocks/RecommendedProductsSlider/RecommendedProductsSlider.config';
import { scoresConfig } from './lib/blocks/Scores/Scores.config';
import { shrinkingArrowConfig } from './lib/blocks/ShrinkingArrow/ShrinkingArrow.config';
import { statsConfig } from './lib/blocks/Stats/Stats.config';
import { statsListConfig } from './lib/blocks/StatsList/StatsList.config';
import { stickyBenefitsConfig } from './lib/blocks/StickyBenefits/StickyBenefits.config';
import { stickyCardsConfig } from './lib/blocks/StickyCards/StickyCards.config';
import { testimonialsSliderConfig } from './lib/blocks/TestimonialsSlider/TestimonialsSlider.config';
import { textBlockConfig } from './lib/blocks/TextBlock/TextBlock.config';
import { textboxesConfig } from './lib/blocks/Textboxes/Textboxes.config';
import { textImageCollageConfig } from './lib/blocks/TextImageCollage/TextImageCollage.config';
import { textImageSplittedEvenlyConfig } from './lib/blocks/TextImageSplittedEvenly/TextImageSplittedEvenly.config';
import { textSliderConfig } from './lib/blocks/TextSlider/TextSlider.config';
import { trustedShopsReviewsConfig } from './lib/blocks/TrustedShopsReviews/TrustedShopsReviews.config';
import { valuesConfig } from './lib/blocks/Values/Values.config';
import { verticalCardsSliderConfig } from './lib/blocks/VerticalCardsSlider/VerticalCardsSlider.config';
import { videoBackgroundConfig } from './lib/blocks/VideoBackground/VideoBackground.config';
import { videoBlockConfig } from './lib/blocks/VideoBlock/VideoBlock.config';

export const blockConfigMap: { [T in ContentBlockId]: BlockConfigExport } = {
  'content.all-blocks': allBlocksConfig,
  'content.article-cta-card-block': articleCTACardBlockConfig,
  'content.article-download': articleDownloadConfig,
  'content.article-embedded-video': articleEmbeddedVideoConfig,
  'content.article-enumeration': articleEnumerationConfig,
  'content.article-faq': articleFAQConfig,
  'content.article-headline': articleHeadlineConfig,
  'content.article-image': articleImageConfig,
  'content.article-image-text-slider': articleImageTextSliderConfig,
  'content.article-link-block': articleLinkBlockConfig,
  'content.article-page-navigation-anchor': articlePageNavigationAnchorConfig,
  'content.article-quote': articleQuoteConfig,
  'content.article-text': articleTextConfig,
  'content.articles': articlesConfig,
  'content.articles-mix': articlesMixConfig,
  'content.author-spotlight': authorSpotlightConfig,
  'content.calculator-charging-cost': calculatorChargingCostConfig,
  'content.calculator-charging-duration': calculatorChargingDurationConfig,
  'content.calculator-savings': calculatorSavingsConfig,
  'content.car-model-selection': carModelSelectionConfig,
  'content.car-model-selection-and-savings': carModelSelectionAndSavingsConfig,
  'content.cards': cardsConfig,
  'content.cards-360-slider': cards360SliderConfig,
  'content.cars': carsConfig,
  'content.checkmarks': checkmarksConfig,
  'content.code-snippet': codeSnippetConfig,
  'content.compare': compareConfig,
  'content.contact': contactConfig,
  'content.contact-help': contactHelpConfig,
  'content.contact-options': contactOptionsConfig,
  'content.contact-support': contactSupportConfig,
  'content.cta': ctaConfig,
  'content.cta-banner': ctaBannerConfig,
  'content.cta-card-block': ctaCardBlockConfig,
  'content.delayed-popup': delayedPopupConfig,
  'content.downloads-and-assets': downloadsAndAssetsConfig,
  'content.enumeration-list': enumerationListConfig,
  'content.et-cancellation-form': eTCancellationFormConfig,
  'content.faq': faqConfig,
  'content.faq-with-tabs': faqWithTabsConfig,
  'content.flipping-logos-with-buttons': flippingLogosWithButtonsConfig,
  'content.footnote': footnoteConfig,
  'content.form': formConfig,
  'content.gallery': galleryConfig,
  'content.get-in-touch': getInTouchConfig,
  'content.growing-arrow': growingArrowConfig,
  'content.growing-graph': growingGraphConfig,
  'content.headline-block': headlineBlockConfig,
  'content.headline-text-side-by-side': headlineTextSideBySideConfig,
  'content.headline-with-cta-block': headlineWithCTABlockConfig,
  'content.hero': heroConfig,
  'content.hero-full-screen-image': heroFullScreenImageConfig,
  'content.hero-slider': heroSliderConfig,
  'content.hero-text': heroTextConfig,
  'content.hero-video': heroVideoConfig,
  'content.hero-with-breaking-arrow-mask': heroWithBreakingArrowMaskConfig,
  'content.hero-with-onboarding-flow': heroWithOnboardingFlowConfig,
  'content.hero-with-small-image-and-arrow': heroWithSmallImageAndArrowConfig,
  'content.hero-with-static-arrow-mask': heroWithStaticArrowMaskConfig,
  'content.highlighted-product-slider': highlightedProductSliderConfig,
  'content.image': imageBlockConfig,
  'content.image-text': imageTextConfig,
  'content.image-text-slider': imageTextSliderConfig,
  'content.image-text-tiles': imageTextTilesConfig,
  'content.image-textbox-slider': imageTextboxSliderConfig,
  'content.interactive-cards': interactiveCardsConfig,
  'content.interactive-graphic': interactiveGraphicConfig,
  'content.interactive-grid-cards': interactiveGridCardsConfig,
  'content.job-openings': jobOpeningsConfig,
  'content.link-buttons': linkButtonsConfig,
  'content.link-cards-list': linkCardsListConfig,
  'content.milestones-slider': milestonesSliderConfig,
  'content.offer-simulator': offerSimulatorConfig,
  'content.onboarding-flow-eyond': onboardingFlowEyondConfig,
  'content.onboarding-flow-eyond-new-tarrif': onboardingFlowEyondNewTariffConfig,
  'content.onboarding-flow-mercedes': onboardingFlowMercedesConfig,
  'content.onboarding-flow-mobilize-de': onboardingFlowMobilizeDEConfig,
  'content.onboarding-flow-mobilize-fr': onboardingFlowMobilizeFRConfig,
  'content.page-navigation': pageNavigationConfig,
  'content.partners': partnersConfig,
  'content.people-slider': peopleSliderConfig,
  'content.press-mailing-list': pressMailingListConfig,
  'content.products': productsConfig,
  'content.recommended-products-slider': recommendedProductsSliderConfig,
  'content.scores': scoresConfig,
  'content.shrinking-arrow': shrinkingArrowConfig,
  'content.stats': statsConfig,
  'content.stats-list': statsListConfig,
  'content.sticky-benefits': stickyBenefitsConfig,
  'content.sticky-cards': stickyCardsConfig,
  'content.testimonials-slider': testimonialsSliderConfig,
  'content.text': textBlockConfig,
  'content.text-image-collage': textImageCollageConfig,
  'content.text-image-splitted-evenly': textImageSplittedEvenlyConfig,
  'content.text-slider': textSliderConfig,
  'content.textboxes': textboxesConfig,
  'content.trusted-shops-reviews': trustedShopsReviewsConfig,
  'content.values': valuesConfig,
  'content.vertical-cards-slider': verticalCardsSliderConfig,
  'content.video': videoBlockConfig,
  'content.video-background': videoBackgroundConfig,
};
